import { HStack, Text } from '@chakra-ui/react'
import { useColorMode } from 'uikit/ColorMode/ColorMode'

export const PersonFullName = ({ firstName, lastName, middleName }) => {
  const { colorMode } = useColorMode()
  const themeColorEmpty = colorMode === 'light' ? 'gray.300' : 'gray.600'
  return (
    <HStack gap={1}>
      {lastName === null || lastName === '' ? (
        <Text color={themeColorEmpty}>
          <s>Фамилия</s>
        </Text>
      ) : (
        <Text>{lastName}</Text>
      )}
      {firstName === null || firstName === '' ? (
        <Text color={themeColorEmpty}>
          <s>Имя</s>
        </Text>
      ) : (
        <Text>{firstName}</Text>
      )}
      {middleName === null || middleName === '' ? (
        <Text color={themeColorEmpty}>
          <s>Отчество</s>
        </Text>
      ) : (
        <Text>{middleName}</Text>
      )}
    </HStack>
  )
}
